import React, { useState, useEffect } from 'react';
import {
    AppBar,
    Toolbar,
    Button,
    Box,
    Container,
    Typography,
    Menu,
    MenuItem,
    Fade,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Collapse,
    Divider,
} from '@mui/material';
import {
    KeyboardArrowRight,
    Menu as MenuIcon,
    Close as CloseIcon,
    ExpandMore,
    ExpandLess,
} from '@mui/icons-material';
import logo from "../Assests/images/logo.svg"
import { useNavigate, useLocation } from 'react-router-dom';

const NavBar = ({ textColor = '#ffffff', logoTextColor = '#ffffff' }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeMenu, setActiveMenu] = useState(null);
    const [activeNavItem, setActiveNavItem] = useState('Products');

    // Mobile drawer states
    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState({});

    // const handleClick = (event, menuType) => {
    //     setAnchorEl(event.currentTarget);
    //     setActiveMenu(menuType);
    //     setActiveNavItem(menuType);
    // };

    // const handleClick = (event, menuType) => {
    //     // If clicking the same menu, close it
    //     if (activeMenu === menuType) {
    //         setAnchorEl(null);
    //         setActiveMenu(null);
    //     } else {
    //         // Open new menu
    //         setAnchorEl(event.currentTarget);
    //         setActiveMenu(menuType);
    //         setActiveNavItem(menuType);
    //     }
    // };
    const handleClose = () => {
        setAnchorEl(null);
        setActiveMenu(null);
    };

    const handleNavigation = (item, event) => {
        if (item.href) {
            event.preventDefault();
            event.stopPropagation();
            navigate(item.href);
            setActiveNavItem(item.label);
        } else {
            // Prevent default only if there's no href
            event.preventDefault();
            event.stopPropagation();
        }
        setMobileOpen(false);
    };

    const handleDropdownItemClick = (href) => {
        if (href) {
            navigate(href);
        }
        handleClose();
    };

    const handleLogoClick = () => {
        navigate('/');
        setActiveNavItem('Home');
        setMobileOpen(false);
    };

    // Mobile drawer toggle
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    // Mobile submenu toggle
    const handleMobileMenuToggle = (label) => {
        setMobileMenuOpen(prev => ({
            ...prev,
            [label]: !prev[label]
        }));
    };



    const navigationItems = [
        {
            label: 'Products',
            hasDropdown: true,
            isTwoColumn: true,
            leftColumnItems: [
                { label: 'Payment Gateways', desc: 'Designed for speed, built for trust.' },
                { label: 'Payment Integration', desc: 'Fast integration, Frictionless payments.' },
                { label: 'Payouts', desc: 'Move money effortlessly with Zutopay.' },
                { label: 'QR Code Solutions', desc: 'Scan, Pay, Done.' },
                { label: 'Domestic Payments', desc: 'Local level payments made simple.' },
                { label: 'PoS Solutions', desc: 'We offers a wide range of products, including (POS) terminals' }
            ],
            rightColumnItems: [
                { label: 'Hosted Payment Gateways', desc: 'Easy to set up, low risk',},
                { label: 'Self-Hosted Payment Gateways', desc: 'Full branding control', },
                { label: 'Local Bank Integration Gateways', desc: 'Familiar for users, simple to integrate', },
                { label: 'Mobile Payment Gateways', desc: 'Fast and user-friendly', }
            ]
        },
        {
            label: 'Developers',
            href: '/developers',
            hasDropdown: true,
            isTwoColumn: false,
            dropdownItems: [
                { label: 'Developer Documentation', desc: 'Start your integration', href: '/company/developers', isHighlighted: true },
                { label: 'API References', desc: "Explore our API's" }
            ]
        },
        {
            label: 'Industry',
            href: '/industry',
            hasDropdown: true,
            isTwoColumn: false,
            dropdownItems: [
                { label: 'Travel', desc: 'Travel light. Pay smart.' },
                { label: 'Insurance', desc: 'One app for all your coverage payments.' },
                { label: 'Edutech', desc: 'Smart payments, smarter learning.' },
                { label: 'E-Commerce', desc: 'E-commerce payments made effortless.' },
                { label: 'Wealth', desc: 'Payments that move with your money.' },
                { label: 'Corporate', desc: 'Fast. Secure. Scalable. Built for corporates.' }
            ]
        },
        {
            label: 'Pricing',
            
            hasDropdown: false
        },
        {
            label: 'Company',
            
            hasDropdown: true,
            isTwoColumn: false,
            dropdownItems: [
                { label: 'About Us', desc: 'Zutopay is here to make payments easy for everyone.', href: '/company/about-us', isHighlighted: true },
                { label: 'Board of Directors', desc: 'Building trust and growth through expert guidance.' },
                { label: 'Blogs & News', desc: 'Insights, Innovations & Announcements' },
                { label: 'Careers', desc: 'Work for Zutopay, Grow your knowledge' },
                { label: 'Contact Us', desc: 'Get in Touch with Zutopay'}
            ]
        },
    ];

    // Set active nav item based on current route
    useEffect(() => {
        const currentPath = location.pathname;

        // Check if current path matches any navigation item
        const activeItem = navigationItems.find(item => {
            // Check main href
            if (item.href === currentPath) return true;

            // Check dropdown items
            if (item.dropdownItems) {
                return item.dropdownItems.some(subItem => subItem.href === currentPath);
            }

            // Check two-column items
            if (item.leftColumnItems || item.rightColumnItems) {
                const leftMatch = item.leftColumnItems?.some(subItem => subItem.href === currentPath);
                const rightMatch = item.rightColumnItems?.some(subItem => subItem.href === currentPath);
                return leftMatch || rightMatch;
            }

            return false;
        });

        if (activeItem) {
            setActiveNavItem(activeItem.label);
        } else if (currentPath === '/') {
            setActiveNavItem('Home');
        } else {
            setActiveNavItem('');
        }
    }, [location.pathname]);

    // Mobile Drawer Content
    const drawer = (
        <Box sx={{ width: 280, height: '100%', bgcolor: '#fff' }}>
            {/* Drawer Header */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
            }}>
                <Box onClick={handleLogoClick} sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}>
                    <Box component="img" src={logo} alt="ZutoPay Logo" sx={{ width: "30px", height: "auto" }} />
                    <Typography sx={{
                        color: '#000',
                        fontSize: '1.5rem',
                        fontWeight: 500,
                        fontFamily: "'Inter', sans-serif",
                        letterSpacing: '-0.5px',
                        fontStyle: 'italic',
                        textTransform: 'lowercase',
                    }}>
                        zutopay
                    </Typography>
                </Box>
                <IconButton onClick={handleDrawerToggle}>
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* Mobile Navigation List */}
            <List sx={{ px: 1, py: 2 }}>
                {navigationItems.map((item, index) => (
                    <Box key={item.label}>
                        <ListItem
                            button
                            onClick={() => {
                                if (item.hasDropdown) {
                                    handleMobileMenuToggle(item.label);
                                } else {
                                    handleNavigation(item, null);
                                }
                            }}
                            sx={{
                                borderRadius: 1,
                                mb: 0.5,
                                '&:hover': { bgcolor: 'rgba(0, 212, 170, 0.08)' }
                            }}
                        >
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    fontWeight: 500,
                                    color: '#1a1a1a'
                                }}
                            />
                            {item.hasDropdown && (
                                mobileMenuOpen[item.label] ? <ExpandLess /> : <ExpandMore />
                            )}
                        </ListItem>

                        {/* Mobile Submenu */}
                        {item.hasDropdown && (
                            <Collapse in={mobileMenuOpen[item.label]} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {/* Two Column Items */}
                                    {item.isTwoColumn && (
                                        <>
                                            {item.leftColumnItems.map(subItem => (
                                                <ListItem
                                                    key={subItem.label}
                                                    button
                                                    onClick={() => handleDropdownItemClick(subItem.href)}
                                                    sx={{ pl: 4, py: 1 }}
                                                >
                                                    <ListItemText
                                                        primary={subItem.label}
                                                        secondary={subItem.desc}
                                                        primaryTypographyProps={{
                                                            fontSize: '0.9rem',
                                                            fontWeight: 500
                                                        }}
                                                        secondaryTypographyProps={{
                                                            fontSize: '0.75rem',
                                                            color: '#888'
                                                        }}
                                                    />
                                                </ListItem>
                                            ))}
                                            {item.rightColumnItems.map(subItem => (
                                                <ListItem
                                                    key={subItem.label}
                                                    button
                                                    onClick={() => handleDropdownItemClick(subItem.href)}
                                                    sx={{ pl: 4, py: 1 }}
                                                >
                                                    <ListItemText
                                                        primary={subItem.label}
                                                        secondary={subItem.desc}
                                                        primaryTypographyProps={{
                                                            fontSize: '0.9rem',
                                                            fontWeight: 500
                                                        }}
                                                        secondaryTypographyProps={{
                                                            fontSize: '0.75rem',
                                                            color: '#888'
                                                        }}
                                                    />
                                                </ListItem>
                                            ))}
                                        </>
                                    )}

                                    {/* Single Column Items */}
                                    {!item.isTwoColumn && item.dropdownItems.map(subItem => (
                                        <ListItem
                                            key={subItem.label}
                                            button
                                            onClick={() => handleDropdownItemClick(subItem.href)}
                                            sx={{
                                                pl: 4,
                                                py: 1,
                                                borderLeft: subItem.isHighlighted ? '3px solid #00d4aa' : 'none',
                                                bgcolor: subItem.isHighlighted ? 'rgba(0, 212, 170, 0.04)' : 'transparent'
                                            }}
                                        >
                                            <ListItemText
                                                primary={subItem.label}
                                                secondary={subItem.desc}
                                                primaryTypographyProps={{
                                                    fontSize: '0.9rem',
                                                    fontWeight: 500,
                                                    color: subItem.isHighlighted ? '#00d4aa' : '#1a1a1a'
                                                }}
                                                secondaryTypographyProps={{
                                                    fontSize: '0.75rem',
                                                    color: '#888'
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        )}
                        {index < navigationItems.length - 1 && <Divider sx={{ my: 1 }} />}
                    </Box>
                ))}
            </List>

            {/* Mobile Sign Up Button */}
            <Box sx={{ p: 2 }}>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={() => {
                        navigate('/signup');
                        setMobileOpen(false);
                    }}
                    sx={{
                        background: 'linear-gradient(135deg, #00d4aa 0%, #00b894 100%)',
                        color: '#ffffff',
                        textTransform: 'capitalize',
                        fontWeight: 500,
                        padding: '12px',
                        borderRadius: '8px',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #00b894 0%, #00a085 100%)',
                        },
                    }}
                >
                    Sign Up
                </Button>
            </Box>
        </Box>
    );

    return (
        <>
            <AppBar
                sx={{
                    position: "absolute",
                    top: { xs: "10px", md: "20px" },
                    left: 0,
                    right: 0,
                    background: 'transparent',
                    backdropFilter: 'none',
                    boxShadow: 'none',
                    zIndex: 1100,
                    px: { xs: 2, md: 4 }
                }}
            >
                <Container maxWidth="xl">
                    <Toolbar
                        sx={{
                            display: "flex",
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            minHeight: { xs: '64px', md: '70px' }
                        }}
                    >
                        {/* Logo Section */}
                        <Box
                            onClick={handleLogoClick}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: { xs: 0.5, md: 1 },
                                flexGrow: 0,
                                cursor: 'pointer',
                            }}
                        >
                            <Box
                                component="img"
                                src={logo}
                                alt="ZutoPay Logo"
                                sx={{
                                    width: { xs: "30px", md: "38px" },
                                    height: "auto",
                                    display: 'block',
                                }}
                            />
                            <Typography
                                sx={{
                                    color: logoTextColor,
                                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                                    fontWeight: 500,
                                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                                    letterSpacing: '-1px',
                                    fontStyle: 'italic',
                                    textTransform: 'lowercase',
                                    lineHeight: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                zutopay
                            </Typography>
                        </Box>

                        {/* Desktop Navigation Links */}
                        <Box
                            sx={{
                                display: { xs: 'none', lg: 'flex' },
                                gap: 1,
                                alignItems: 'center',
                            }}
                        >
                            {navigationItems.map((item, index) => (
                                <Box
                                    key={item.label}
                                    sx={{ position: 'relative' }}
                                    onMouseEnter={(e) => {
                                        if (item.hasDropdown) {
                                            setAnchorEl(e.currentTarget);
                                            setActiveMenu(item.label);
                                            // setActiveNavItem(item.label);
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        // Only close if not moving to the menu
                                        const relatedTarget = e.relatedTarget;
                                        // Check if relatedTarget exists and has the closest method
                                        if (!relatedTarget ||
                                            (typeof relatedTarget.closest !== 'function') ||
                                            !relatedTarget.closest('.MuiMenu-paper')) {
                                            setTimeout(() => {
                                                if (activeMenu === item.label) {
                                                    handleClose();
                                                }
                                            }, 150);
                                        }
                                    }}
                                >
                                    <Typography
                                        component="div"
                                        onClick={(e) => {
                                            if (item.hasDropdown) return;
                                            
                                            if (item.href) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleNavigation(item, e);
                                            } else {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }
                                        }}
                                      
                                        sx={{
                                            color: activeNavItem === item.label ? '#00d4aa' : textColor,
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            padding: '8px 16px',
                                            cursor: item.href ? 'pointer' : 'default',
                                            display: 'flex',
                                            alignItems: 'center',
                                            textDecoration: 'none',
                                            transition: 'color 0.3s ease',
                                            '&:hover': {
                                                color: item.href ? '#00d4aa' : 'inherit',
                                            },
                                            '&:active': {
                                                pointerEvents: item.href ? 'auto' : 'none'
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </Typography>

                                    {item.hasDropdown && (
                                        //     open={activeMenu === item.label}
                                        //     onClose={handleClose}
                                        //     TransitionComponent={Fade}
                                        //     sx={{
                                        //         '& .MuiPaper-root': {
                                        //             backgroundColor: '#ffffff',
                                        //             borderRadius: '16px',
                                        //             boxShadow: '0 12px 48px rgba(0, 0, 0, 0.15)',
                                        //             minWidth: item.isTwoColumn ? '800px' : '350px',
                                        //             mt: 1.5,
                                        //             border: '1px solid rgba(0, 0, 0, 0.08)',
                                        //             overflow: 'hidden',
                                        //         },
                                        //     }}
                                        //     anchorOrigin={{
                                        //         vertical: 'bottom',
                                        //         horizontal: 'center',
                                        //     }}
                                        //     transformOrigin={{
                                        //         vertical: 'top',
                                        //         horizontal: 'center',
                                        //     }}
                                        // >
                                        // <Menu
                                        //     anchorEl={anchorEl}
                                        //     open={activeMenu === item.label}
                                        //     onClose={handleClose}
                                        //     TransitionComponent={Fade}
                                        //     MenuListProps={{
                                        //         onMouseEnter: () => {
                                        //             // Keep menu open when hovering over it
                                        //         },
                                        //         onMouseLeave: () => {
                                        //             handleClose();
                                        //         },
                                        //     }}
                                        //     sx={{
                                        //         '& .MuiPaper-root': {
                                        //             backgroundColor: '#ffffff',
                                        //             borderRadius: '16px',
                                        //             boxShadow: '0 12px 48px rgba(0, 0, 0, 0.15)',
                                        //             minWidth: item.isTwoColumn ? '800px' : '350px',
                                        //             mt: 1.5,
                                        //             border: '1px solid rgba(0, 0, 0, 0.08)',
                                        //             overflow: 'hidden',
                                        //         },
                                        //     }}
                                        //     anchorOrigin={{
                                        //         vertical: 'bottom',
                                        //         horizontal: 'center',
                                        //     }}
                                        //     transformOrigin={{
                                        //         vertical: 'top',
                                        //         horizontal: 'center',
                                        //     }}
                                        // >
                                        // <Menu
                                        //     anchorEl={anchorEl}
                                        //     open={activeMenu === item.label}
                                        //     onClose={handleClose}
                                        //     TransitionComponent={Fade}
                                        //     disableAutoFocusItem
                                        //     MenuListProps={{
                                        //         onMouseLeave: (e) => {
                                        //             // Check if mouse is leaving to outside the menu
                                        //             const relatedTarget = e.relatedTarget;
                                        //             // Ensure relatedTarget exists and has closest method before using it
                                        //             if (!relatedTarget ||
                                        //                 (typeof relatedTarget.closest !== 'function') ||
                                        //                 !relatedTarget.closest('[data-nav-item]')) {
                                        //                 handleClose();
                                        //             }
                                        //         },
                                        //         sx: { py: 0 }
                                        //     }}
                                        //     sx={{
                                        //         '& .MuiPaper-root': {
                                        //             backgroundColor: '#ffffff',
                                        //             borderRadius: '16px',
                                        //             boxShadow: '0 12px 48px rgba(0, 0, 0, 0.15)',
                                        //             minWidth: item.isTwoColumn ? '800px' : '350px',
                                        //             mt: 0.5, // Reduced gap
                                        //             border: '1px solid rgba(0, 0, 0, 0.08)',
                                        //             overflow: 'hidden',
                                        //         },
                                        //     }}
                                        //     anchorOrigin={{
                                        //         vertical: 'bottom',
                                        //         horizontal: 'center',
                                        //     }}
                                        //     transformOrigin={{
                                        //         vertical: 'top',
                                        //         horizontal: 'center',
                                        //     }}
                                        // >
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={activeMenu === item.label}
                                            onClose={handleClose}
                                            TransitionComponent={Fade}
                                            disableAutoFocusItem
                                            slotProps={{
                                                paper: {
                                                    onMouseLeave: (e) => {
                                                        // Check if mouse is leaving to outside the menu
                                                        const relatedTarget = e.relatedTarget;
                                                        // Ensure relatedTarget exists and has closest method before using it
                                                        if (!relatedTarget ||
                                                            (typeof relatedTarget.closest !== 'function') ||
                                                            !relatedTarget.closest('[data-nav-item]')) {
                                                            handleClose();
                                                        }
                                                    },
                                                    sx: { py: 0 }
                                                }
                                            }}
                                            sx={{
                                                '& .MuiPaper-root': {
                                                    backgroundColor: '#ffffff',
                                                    borderRadius: '16px',
                                                    boxShadow: '0 12px 48px rgba(0, 0, 0, 0.15)',
                                                    minWidth: item.isTwoColumn ? '800px' : '350px',
                                                    mt: 0.5,
                                                    border: '1px solid rgba(0, 0, 0, 0.08)',
                                                    overflow: 'hidden',
                                                },
                                            }}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                        >
                                            {item.isTwoColumn ? (
                                                <Box sx={{ display: 'flex', minHeight: '420px' }}>
                                                    <Box sx={{
                                                        flex: 1,
                                                        borderRight: '1px solid rgba(0, 0, 0, 0.08)',
                                                        py: 2
                                                    }}>
                                                        {item.leftColumnItems.map((leftItem, leftIndex) => (
                                                            <MenuItem
                                                                key={leftItem.label}
                                                                onClick={() => handleDropdownItemClick(leftItem.href)}
                                                                sx={{
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    padding: '18px 28px',
                                                                    borderBottom: leftIndex < item.leftColumnItems.length - 1 ?
                                                                        '1px solid rgba(0, 0, 0, 0.06)' : 'none',
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(0, 212, 170, 0.04)',
                                                                    },
                                                                    '&:last-child': {
                                                                        borderBottom: 'none',
                                                                    },
                                                                }}
                                                            >
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    width: '100%',
                                                                    mb: 1
                                                                }}>
                                                                    <Typography
                                                                        sx={{
                                                                            fontWeight: 600,
                                                                            color: leftIndex === 0 ? '#00d4aa' : '#1a1a1a',
                                                                            fontSize: '1rem',
                                                                        }}
                                                                    >
                                                                        {leftItem.label}
                                                                    </Typography>
                                                                    <KeyboardArrowRight
                                                                        sx={{
                                                                            fontSize: '20px',
                                                                            color: '#999',
                                                                            ml: 2
                                                                        }}
                                                                    />
                                                                </Box>
                                                                <Typography
                                                                    sx={{
                                                                        color: '#888',
                                                                        fontSize: '0.9rem',
                                                                        lineHeight: 1.5,
                                                                    }}
                                                                >
                                                                    {leftItem.desc}
                                                                </Typography>
                                                            </MenuItem>
                                                        ))}
                                                    </Box>

                                                    <Box sx={{ flex: 1, py: 2 }}>
                                                        {item.rightColumnItems.map((rightItem, rightIndex) => (
                                                            <MenuItem
                                                                key={rightItem.label}
                                                                onClick={() => handleDropdownItemClick(rightItem.href)}
                                                                sx={{
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    padding: '18px 28px',
                                                                    borderBottom: rightIndex < item.rightColumnItems.length - 1 ?
                                                                        '1px solid rgba(0, 0, 0, 0.06)' : 'none',
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(0, 212, 170, 0.04)',
                                                                    },
                                                                }}
                                                            >
                                                                <Typography
                                                                    sx={{
                                                                        fontWeight: 600,
                                                                        color: '#1a1a1a',
                                                                        fontSize: '1rem',
                                                                        mb: 1,
                                                                    }}
                                                                >
                                                                    {rightItem.label}
                                                                </Typography>
                                                                <Typography
                                                                    sx={{
                                                                        color: '#888',
                                                                        fontSize: '0.9rem',
                                                                        lineHeight: 1.5,
                                                                    }}
                                                                >
                                                                    {rightItem.desc}
                                                                </Typography>
                                                            </MenuItem>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            ) : (
                                                <Box sx={{ py: 2 }}>
                                                    {item.dropdownItems.map((dropdownItem, dropdownIndex) => (
                                                        <MenuItem
                                                            key={dropdownItem.label}
                                                            onClick={() => handleDropdownItemClick(dropdownItem.href)}
                                                            sx={{
                                                                flexDirection: 'column',
                                                                alignItems: 'flex-start',
                                                                padding: '18px 28px',
                                                                borderBottom: dropdownIndex < item.dropdownItems.length - 1 ?
                                                                    '1px solid rgba(0, 0, 0, 0.06)' : 'none',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(0, 212, 170, 0.04)',
                                                                },
                                                                position: 'relative',
                                                                borderLeft: dropdownItem.isHighlighted ? '4px solid #00d4aa' : 'none',
                                                                backgroundColor: dropdownItem.isHighlighted ?
                                                                    'rgba(0, 212, 170, 0.02)' : 'transparent',
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 600,
                                                                    color: dropdownItem.isHighlighted ? '#00d4aa' : '#1a1a1a',
                                                                    fontSize: '1rem',
                                                                    mb: 1,
                                                                }}
                                                            >
                                                                {dropdownItem.label}
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    color: '#888',
                                                                    fontSize: '0.9rem',
                                                                    lineHeight: 1.5,
                                                                }}
                                                            >
                                                                {dropdownItem.desc}
                                                            </Typography>
                                                        </MenuItem>
                                                    ))}
                                                </Box>
                                            )}
                                        </Menu>
                                    )}
                                </Box>
                            ))}
                            <Button
                                variant="contained"
                                onClick={() => navigate('/signup')}
                                sx={{
                                    background: 'linear-gradient(135deg, #00d4aa 0%, #00b894 100%)',
                                    color: '#ffffff',
                                    textTransform: 'capitalize',
                                    fontWeight: 400,
                                    padding: '10px 20px',
                                    borderRadius: '10px',
                                    minWidth: '120px',
                                    ml: 2,
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #00b894 0%, #00a085 100%)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 4px 12px rgba(0, 212, 170, 0.3)',
                                    },
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                Sign Up
                            </Button>
                        </Box>

                        {/* Mobile Menu Button */}
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{
                                display: { lg: 'none' },
                                color: textColor
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Toolbar>
                </Container>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                variant="temporary"
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile
                }}
                sx={{
                    display: { xs: 'block', lg: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 300 },
                }}
            >
                {drawer}
            </Drawer>
        </>
    );
};

export default NavBar;